/*
 * Built with Common Launchpad 2.0.3
 */

import $ from 'jquery';
// import Vue App
import Vue from 'vue';
import VueApp from '~/src/custom/vue/apps/web-qualifier-tool/web-qualifier-tool.js';
import App from '~/src/custom/vue/apps/containers/web-qualifier-tool.vue';

// connect vue component and init app
Vue.component('app', App);
VueApp.$mount('#wqt-app');

class QualifierToolWidget {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
       this.inputSetState();
    }

    inputSetState() {
        $('body').on('blur', '.qualifier-tool-question-input-container input', this.updateInputState);        
    }

    updateInputState() {
        if ($(this).val().length > 0) {
            $(this).parent().addClass('active');
        } else {
            $(this).parent().removeClass('active');
        }
    }
}

export default QualifierToolWidget;

$(() => {
	const qualifierToolWidget = new QualifierToolWidget();
	qualifierToolWidget.init();
});